module.exports = __webpack_public_path__ + "img/mision.fb4f7919.png";